/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import {
  Grid,
  FormControl,
  Button,
  Select,
  MenuItem,
  TextField,
} from '@material-ui/core'
import { useForm } from '../../../../context/formContext'
import { useAuthentication } from '../../../../context/authenticationContext'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import ReactTooltip from 'react-tooltip'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import './crearFormulario.scss'
import es from 'react-phone-input-2/lang/es.json'

const LocationData = (props) => {
  const { nextStep, previousStep } = props
  const {
    setStep,
    step,
    setPreEligibilityForm,
    preEligibilityForm,
    departments,
    municipilaties,
    setMunicipilatiesID,
    municipilatiesID,
    getMunicipalityList,
    userActualCountry,
    editForm,
  } = useForm()
  const { userCountry } = useAuthentication()
  const [showMunicipality, setShowMunicipality] = useState(false)

  const LocationDataSchema = Yup.object().shape({
    idDepartment: Yup.number().required('Este campo es obligatorio'),
    idMunicipality: Yup.number()
      .required('Este campo es obligatorio')
      .test('superior', 'Este campo es obligatorio', function (f) {
        const ref = 0
        return f > this.resolve(ref)
      }),
    companyPhone: Yup.string()
      .min(5, 'Es necesario completar este campo')
      .required('Este campo es obligatorio'),
    companyAddress: Yup.string().required('Este campo es obligatorio'),
  })

  const formik = useFormik({
    initialValues: {
      idDepartment:
        editForm.list && editForm.list.Project.IdDepartment
          ? editForm.list.Project.IdDepartment
          : '',
      idMunicipality:
        editForm.list && editForm.list.Project.IdMunicipality
          ? editForm.list.Project.IdMunicipality
          : '',
      companyPhone:
        editForm.list && editForm.list.Project.Phone
          ? editForm.list.Project.Phone
          : '',
      companyAddress:
        editForm.list && editForm.list.Project.Address
          ? editForm.list.Project.Address
          : '',

      idCountry: userCountry,
    },
    validationSchema: LocationDataSchema,
    onSubmit: (values) => {
      next()
    },
  })

  useEffect(() => {
    if (formik.values.idDepartment !== 0 && formik.values.idDepartment !== '') {
      setShowMunicipality(true)
    } else {
      setShowMunicipality(false)
      setPreEligibilityForm({
        ...preEligibilityForm,
        idCountry: parseInt(userCountry),
        idDepartment: '',
        idMunicipality: 0,
        companyPhone: '',
        companyAddress: '',
      })
    }
  }, [formik.values.idDepartment])

  const next = () => {
    setStep(step + 1)
    setPreEligibilityForm({
      ...preEligibilityForm,
      idDepartment:
        formik.values.idDepartment !== preEligibilityForm.idDepartment
          ? preEligibilityForm.idDepartment
          : formik.values.idDepartment,
      idMunicipality:
        formik.values.idMunicipality !== preEligibilityForm.idMunicipality
          ? preEligibilityForm.idMunicipality
          : formik.values.idMunicipality,
      companyPhone:
        formik.values.companyPhone !== preEligibilityForm.companyPhone
          ? preEligibilityForm.companyPhone
          : formik.values.companyPhone,
      companyAddress:
        formik.values.companyAddress !== preEligibilityForm.companyAddress
          ? preEligibilityForm.companyAddress
          : formik.values.companyAddress,
      idCountry: parseInt(formik.values.idCountry),
    })
    nextStep()
  }

  const previous = () => {
    setStep(step - 1)
    previousStep()
  }

  useEffect(() => {
    if (municipilatiesID !== '' && municipilatiesID !== null) {
      getMunicipalityList()
      setShowMunicipality(true)
    }
  }, [municipilatiesID])

  useEffect(() => {
    if (formik.values.idDepartment !== null) {
      setMunicipilatiesID(formik.values.idDepartment)
    }
  }, [formik.values.idDepartment])

  useEffect(() => {
    if (editForm.list && editForm.list.Project.Phone) {
      setPhone(editForm.list.Project.Phone)
      formik.setFieldValue('companyPhone', editForm.list.Project.Phone)
    }
  }, [editForm.list])

  const [phone, setPhone] = useState(userCountry === '7' ? '1809' : '')
  const [editableCode, setEditableCode] = useState(false)
  const [backup, setBackup] = useState('')

  const handleEdit = (e) => {
    if (phone !== '') {
      setBackup(phone)
    } else {
      setBackup('')
    }

    if (e.key === 'Backspace' && phone.length <= 4) {
      setEditableCode(false)
    } else {
      setEditableCode(true)
    }
  }

  useEffect(() => {
    if (backup !== '') {
      if (phone === '' || phone.charAt(0) !== '1' || phone.length < 4) {
        setPhone(backup)
        formik.setFieldValue('companyPhone', backup)
      }
    }
  }, [phone])

  const handleIdDeparment = (value) => {
    formik.setValues({
      ...formik.values,
      idDepartment: value,
      idMunicipality: '',
    })

    if (!formik.errors.idDepartment) {
      setMunicipilatiesID(value)
    }

    setPreEligibilityForm({
      ...preEligibilityForm,
      idDepartment: value,
      idMunicipality: '',
    })
  }

  return (
    <>
      <form id="location-data-form" onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                11. País de la MIPYME <span style={{ color: 'red' }}></span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <TextField
                  id="country"
                  style={{ width: '100%' }}
                  disabled
                  variant="outlined"
                  value={userActualCountry}
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                12. Departamento/Provincia
                <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <Select
                  id="idDepartment"
                  value={formik.values.idDepartment}
                  onChange={(e) => {
                    handleIdDeparment(e.target.value)
                  }}
                  variant="outlined"
                  error={formik.errors.idDepartment}
                >
                  <MenuItem value={''}>Seleccione una opción</MenuItem>
                  {departments &&
                    departments.map((item, key) => (
                      <MenuItem key={key} value={item.IdDepartment}>
                        {item.Description}
                      </MenuItem>
                    ))}
                </Select>
                {formik.errors.idDepartment ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.idDepartment}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          {showMunicipality === true ? (
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  13. Municipio o equivalente del subproyecto
                  <a
                    data-tip="Ingrese el municipio o equivalente donde<br/> se llevará a cabo el subproyecto."
                    data-for="infoMunicipio"
                    style={{ cursor: 'pointer' }}
                  >
                    <ErrorOutlineIcon fontSize="small" />
                    <ReactTooltip
                      id="infoMunicipio"
                      effect="solid"
                      multiline={true}
                      type="dark"
                      place="right"
                    />
                  </a>
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl fullWidth>
                  <Select
                    id="idMunicipality"
                    style={{ width: '100%' }}
                    error={formik.errors.idMunicipality}
                    variant="outlined"
                    onChange={(e) => {
                      formik.setFieldValue('idMunicipality', e.target.value)
                      setPreEligibilityForm({
                        ...preEligibilityForm,
                        idMunicipality: e.target.value,
                      })
                    }}
                    value={formik.values.idMunicipality}
                  >
                    <MenuItem value={''}>Seleccione una opción</MenuItem>
                    {municipilaties &&
                      municipilaties.map((item, key) => (
                        <MenuItem key={key} value={item.IdMunicipality}>
                          {item.Description}
                        </MenuItem>
                      ))}
                  </Select>

                  {formik.errors.idMunicipality ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.idMunicipality}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>
          ) : (
            <p></p>
          )}

          <Grid
            container
            md={12}
            sm={12}
            spacing={1}
            style={{ marginTop: '10px' }}
          >
            <Grid item xs={12} sm={12} md={12}>
              <label style={{ fontWeight: '500' }} className="responsiveLabel">
                Teléfono {''}
                <span style={{ color: 'red' }}>*</span>
                <a
                  data-tip="El número de teléfono o celular no debe llevar guion."
                  data-for="infoPhone"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoPhone"
                    effect="solid"
                    multiline={true}
                    type="dark"
                    place="right"
                  />
                </a>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <PhoneInput
                localization={es}
                country={
                  userCountry === '1'
                    ? 'cr'
                    : userCountry === '2'
                    ? 'gt'
                    : userCountry === '3'
                    ? 'hn'
                    : userCountry === '4'
                    ? 'ni'
                    : userCountry === '5'
                    ? 'sv'
                    : userCountry === '6'
                    ? 'pa'
                    : userCountry === '7'
                    ? 'do'
                    : ''
                }
                onlyCountries={
                  userCountry === '1'
                    ? ['cr']
                    : userCountry === '2'
                    ? ['gt']
                    : userCountry === '3'
                    ? ['hn']
                    : userCountry === '4'
                    ? ['ni']
                    : userCountry === '5'
                    ? ['sv']
                    : userCountry === '6'
                    ? ['pa']
                    : userCountry === '7'
                    ? ['do']
                    : []
                }
                masks={{
                  pa: '........',
                  hn: '........',
                  ni: '........',
                  gt: '........',
                  cr: '........',
                  sv: '........',
                  do: '(...) ........',
                }}
                countryCodeEditable={userCountry !== '7' ? false : editableCode}
                enableAreaCodes={true}
                enableAreaCodeStretch
                areaCodes={{ do: ['809', '829', '849'] }}
                disableDropdown={userCountry !== '7'}
                inputClass="phone"
                inputProps={{
                  name: 'phone',
                  required: true,
                  autoFocus: true,
                  autoComplete: 'off',
                }}
                value={phone}
                onKeyDown={(e) => (userCountry === '7' ? handleEdit(e) : '')}
                onChange={(phone) => {
                  setPhone(phone)
                  formik.setFieldValue('companyPhone', phone)
                  setPreEligibilityForm({
                    ...preEligibilityForm,
                    companyPhone: phone,
                  })
                }}
                dropdownClass={userCountry === '7' ? 'dropClass' : ''}
              />
              {formik.errors.companyPhone ? (
                <div
                  style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                >
                  {formik.errors.companyPhone}
                </div>
              ) : null}
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                Dirección <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <TextField
                  style={{ width: '100%' }}
                  variant="outlined"
                  error={formik.errors.companyAddress}
                  inputProps={{ autoComplete: 'new-text', maxLength: 100 }}
                  value={formik.values.companyAddress}
                  onChange={(e) => {
                    formik.setFieldValue('companyAddress', e.target.value)
                    setPreEligibilityForm({
                      ...preEligibilityForm,
                      companyAddress: e.target.value,
                    })
                  }}
                />
                {formik.errors.companyAddress ? (
                  <div
                    style={{ color: 'red', marginTop: '3px', fontSize: '13px' }}
                  >
                    {formik.errors.companyAddress}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="button__container">
            <Grid item xs={12} sm={6} md={6} style={{ textAlign: 'left' }}>
              <Button
                onClick={() => previous()}
                variant="contained"
                className="button__wizard button__previous"
              >
                Anterior
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={6} style={{ textAlign: 'right' }}>
              <Button
                /* onClick={()=> next()} */ type="submit"
                variant="contained"
                className="button__wizard button__next"
              >
                Siguiente
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default LocationData
